export function isMobileDevice(): boolean {
  if (typeof navigator !== 'undefined') {
    return /Modile|Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
  }
  return false;
}

export function isMobileScreenSize(): boolean {
  const mobileSize = 992;
  return window.innerWidth < mobileSize;
}

export function isSmallMobileScreenSize(): boolean {
  const smallMobileSize = 480;
  return window.innerWidth < smallMobileSize;
}
